import conversationTypes from './conversations.types';
import { takeLatest, put, all, call } from 'redux-saga/effects';
import { 
	handleAddConversation, 
	handleFetchConversations, 
	handleDeleteConversation, 
	handleFetchConversation, 
	handleFetchConversationsByService, 
	handleFetchCustomerConversations 
} from './conversations.helpers';
import { auth } from './../../firebase/utils';

import { fetchCustomerConversationsStart,setConversations, setConversation } from './conversations.actions';

export function* addConversation({ payload }) {

	try {
	  const timestamp = new Date();
	  const  id  = auth.currentUser.uid
	  yield handleAddConversation(id,{
		  ...payload,
		  createdDate: timestamp,
	  });
	  yield put(
		fetchCustomerConversationsStart()
		
	  );
  
  
	} catch (err) {
	  console.log(err);
	}
  
}

export function* onAddConversationStart() {
	yield takeLatest(conversationTypes.ADD_NEW_CONVERSATION_START, addConversation);
}

//fetch all conversations by ID
export function* fetchConversations({ payload }) {
	try {
		const  id  = auth.currentUser.uid
	  const conversations = yield handleFetchConversations(id, payload);
	  yield put(
		  setConversations(conversations)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchConversationsStart() {
	yield takeLatest(conversationTypes.FETCH_CONVERSATIONS_START, fetchConversations);
}

export function* deleteConversation({ payload }) {
	try {
      const  id  = auth.currentUser.uid
      yield handleDeleteConversation(id, payload);
      yield put (
		fetchCustomerConversationsStart()
	  );
  
	} catch (err) {
	  // console.log(err);
	}
}
  
export function* onDeleteConversationStart() {
	yield takeLatest(conversationTypes.DELETE_CONVERSATION_START, deleteConversation);
}

export function* fetchConversation({ payload }) {
	try {
	  const conversation = yield handleFetchConversation(payload);
	  yield put(
	  	setConversation(conversation)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchConversationStart() {
	yield takeLatest(conversationTypes.FETCH_CONVERSATION_START, fetchConversation);
}

//fetch conversations by id, service
export function* fetchConversationsByService({ payload }) {
	try {
		const  id  = auth.currentUser.uid
	  const conversations = yield handleFetchConversationsByService(id, payload);
	  yield put(
		  setConversations(conversations)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchConversationsByServiceStart() {
	yield takeLatest(conversationTypes.FETCH_CONVERSATION_SERVICE_START, fetchConversationsByService);
}

export function* fetchCustomerConversations({ payload }) {
	try {
	
	  const conversations = yield handleFetchCustomerConversations(payload);
	  yield put(
		  setConversations(conversations)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchCustomerConversationsStart() {
	yield takeLatest(conversationTypes.FETCH_CUSTOMER_CONVERSATION_START, fetchCustomerConversations);
}

export default function* conversationsSagas() {
  yield all([
    call(onAddConversationStart),
    call(onFetchConversationsStart),
    call(onDeleteConversationStart),
    call(onFetchConversationStart),
    call(onFetchConversationsByServiceStart),
    call(onFetchCustomerConversationsStart),
  ])
}